export class TranslatedError extends Error {
  constructor(translationKey, interpolationOptions = {}) {
    super(`TranslatedError(${translationKey}) (${JSON.stringify(interpolationOptions)})`);
    this.translationKey = translationKey;
    this.interpolationOptions = interpolationOptions;
    this.name = "TranslatedError";
  }

}